import React from 'react';
import { Container, Row, Col, Breadcrumb, Button, Image } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";

import { FaArrowLeft } from "react-icons/fa";
import './courseHeader.module.css';
import { LinkContainer } from 'react-router-bootstrap';
import { retina_student_panel_url } from '../../constants/const'

import CourseBg from '../../assets/images/banners/course-bg.jpg';
import './courseHeader.module.css'

const CourseHeader = props => {

    const { title, cover, price, discount, description, session, id } = props;
    const { courseId } = useParams()
    const history = useHistory();

    return (
        <div className="course-header page-header pt-3 pt-md-5"
            style={{
                // backgroundImage: !!cover ? 'url(' + cover + ')' : 'none'
                // backgroundImage: `url(${CourseBg})`
            }}
        >
            <Container className="pb-0 pb-md-5">
                <Row className="py-3 align-items-center">
                    <Col xs={12} md={6} className="mb-4 mb-md-0">
                        {
                            !!cover && <Image className="img-fluid page-header-cover mb-4 d-inline d-md-none" src={cover} />
                        }
                        <div className="w-100 mb-4">
                            {
                                !!title && <h2 className="page-title">{title}</h2>
                            }

                        </div>
                        <div className="w-100">
                            <div className="description" dangerouslySetInnerHTML={{ __html: description }}></div>
                            {/* { !!props.children && props.children } */}
                        </div>
                    </Col>
                    <Col xs={12} md={6}>
                        {
                            !!cover && <Image className="img-fluid page-header-cover mb-4 d-none d-md-inline" src={cover} />
                        }
                        <div className="d-flex flex-column justify-content-center" styleName="course-meta">
                            {/* <span className="text-center" styleName="label">কোর্স ফী</span> */}
                            {/* <div className="d-flex flex-column justify-content-center align-items-center mb-4" styleName="course-meta-price">
                                {price > 0 ? <span className="text-center" styleName="price-new"> {price - discount} টাকা</span> : <span className="text-center" styleName="price-new"> Free</span>}
                                {discount !== 0 && <span className="text-center line-through price-old">{price} টাকা</span>}
                            </div> */}
                            {/* <Button className="custom-btn-dark btn-lg btn btn-primary">Enroll</Button> */}
                            {/* <a styleName="enroll-btn" className="custom-btn-dark btn-lg btn btn-primary" href={`${retina_student_panel_url}/sign-up?courseModuleId=${courseId}`}>Enroll</a> */}
                            <a styleName="enroll-btn" target="_blank" rel='noreferrer' className="enroll-btn btn-lg btn" href={`${retina_student_panel_url}/sign-up?courseModuleId=${id}&title=${title}&description=${description}&price=${price}&discount=${discount}&coverPhoto=${cover}&session=${session}&enroll=${true}`}>Enroll</a>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default CourseHeader;